
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgNoteIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 2a6 6 0 1 0 0 12A6 6 0 0 0 8 2zm0 2.653A1.018 1.018 0 1 1 8 6.69a1.018 1.018 0 0 1 0-2.037zm1.066 6.44c.161 0 .292-.13.292-.291l-.005-.57a.292.292 0 0 0-.292-.291H8.77v-2.42a.292.292 0 0 0-.292-.29H6.934a.292.292 0 0 0-.292.29v.575c0 .16.13.291.292.291h.292v1.55h-.292a.292.292 0 0 0-.292.29v.575c0 .16.13.291.292.291h2.132z",
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8 2a6 6 0 1 0 0 12A6 6 0 0 0 8 2zm0 2.653A1.018 1.018 0 1 1 8 6.69a1.018 1.018 0 0 1 0-2.037zm1.066 6.44c.161 0 .292-.13.292-.291l-.005-.57a.292.292 0 0 0-.292-.291H8.77v-2.42a.292.292 0 0 0-.292-.29H6.934a.292.292 0 0 0-.292.29v.575c0 .16.13.291.292.291h.292v1.55h-.292a.292.292 0 0 0-.292.29v.575c0 .16.13.291.292.291h2.132z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/note-icon.7bfc789c5b61d04b3f1817ce963e994c.svg"),
        {
          React: SvgNoteIcon,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      